var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.574 12.5C16.1737 12.5 18.2982 10.3828 18.2982 7.75C18.2982 5.11719 16.1737 3 13.574 3C10.9744 3 8.8499 5.11719 8.8499 7.75C8.8499 10.3828 10.9744 12.5 13.574 12.5ZM13.574 15.5C17.84 15.5 21.2982 12.0302 21.2982 7.75C21.2982 3.46979 17.84 0 13.574 0C9.30812 0 5.8499 3.46979 5.8499 7.75C5.8499 12.0302 9.30812 15.5 13.574 15.5Z",
    fill: "#0D41E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7283 19.7531C5.20348 21.0651 4.14875 23.0299 3.56913 25.6793C3.44948 26.2262 3.59718 26.7264 4.01703 27.1695C4.46875 27.6462 5.208 28 6.0568 28H22.0568C22.9056 28 23.6448 27.6462 24.0966 27.1695C24.5164 26.7264 24.6641 26.2262 24.5445 25.6793C23.9648 23.0299 22.9101 21.0651 21.3853 19.7531C19.887 18.464 17.6171 17.5312 14.0568 17.5312C10.4965 17.5312 8.22656 18.464 6.7283 19.7531ZM22.0568 31C25.3705 31 28.1834 28.2753 27.4752 25.0381C26.13 18.8896 22.2711 14.5312 14.0568 14.5312C5.84245 14.5312 1.98358 18.8896 0.638443 25.0381C-0.0697603 28.2753 2.74309 31 6.0568 31H22.0568Z",
    fill: "#0D41E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d3b7cb6f43454592518246c9a55eb9a0.svg";
export { ForwardRef as ReactComponent };